import { getTemplateFirstChildContent, parseHTML } from '../../utils/dom'
import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../common/body-element'
import { hideElement, showElement } from '../../utils/dom'

class CartDrawerRelatedProducts extends BaseComponent {
  lastRequestedUrl: string

  connectedCallback(): void {
    this.loadProducts()
  }

  erase(): void {
    this.replaceChildren()

    this.setReady(false)
  }

  loadProducts() {
    if (this.lastRequestedUrl === this.dataset.url) {
      return
    }

    this.lastRequestedUrl = this.dataset.url

    if (!this.dataset.url) {
      return
    }

    this.showPreloader()

    return fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        this.hidePreloader()

        const html = parseHTML(text)
        const template = html.querySelector(
          '[data-sidebar-template="CartDrawer"]',
        )

        const node = getTemplateFirstChildContent(template)

        this.updateByHTML(node)
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show(
          'Error in cart drawer related products',
          'warning',
        )
      })
  }

  updateByHTML = (node: HTMLElement): void => {
    const recommendations = node.querySelector(`#${this.id}`)

    if (!recommendations) {
      return
    }

    const clonedRecommendations = recommendations?.cloneNode(true)

    this.replaceChildren(...clonedRecommendations?.childNodes)

    // const products = this.querySelectorAll('vertical-product-card')
    const products = this.querySelectorAll('[in-cart-related-product]')

    this.setReady(products.length > 0)
  }

  setReady(isReady: boolean): void {
    this.toggleAttribute('is-ready', isReady)
  }

  showPreloader(): void {
    const loadingOverlay = this.querySelector('.loading-overlay')

    showElement(loadingOverlay)
  }

  hidePreloader(): void {
    const loadingOverlay = this.querySelector('.loading-overlay')

    hideElement(loadingOverlay)
  }
}

export default CartDrawerRelatedProducts
